import { Button } from '@svenskaspelab/ui/react/button';
import { SheetClose } from '@svenskaspelab/ui/react/sheet';
import type { ComponentProps, ReactNode } from 'react';

type TipsenSheetCloseProps = ComponentProps<typeof Button>;

/**
 * TipsenSheet footer wrapper.
 *
 * @param props Component props
 * @returns TipsenSheet footer wrapper.
 */
export default function TipsenSheetClose(props: TipsenSheetCloseProps): ReactNode {
  return <SheetClose render={<Button {...props} />} />;
}
